var _path, _line, _line2, _path2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeposit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9858 23.5215C21.428 23.2193 21.5415 22.6159 21.2394 22.1738C20.9372 21.7316 20.3338 21.6181 19.8917 21.9202L20.9858 23.5215ZM15.0977 24.2324L15.0514 25.201L15.0514 25.201L15.0977 24.2324ZM9.92552 22.2176L9.30446 22.9623L9.30446 22.9623L9.92552 22.2176ZM7.54211 11.9658L6.65623 11.5714L6.65623 11.5714L7.54211 11.9658ZM11.2951 7.87594L11.764 8.72474L11.2951 7.87594ZM16.7551 6.87644L16.8929 5.91658L16.8929 5.91658L16.7551 6.87644ZM23.2034 14.4812C23.2747 15.012 23.7629 15.3844 24.2937 15.313C24.8244 15.2417 25.1968 14.7535 25.1255 14.2228L23.2034 14.4812ZM19.8917 21.9202C18.4975 22.8728 16.8307 23.3446 15.1441 23.2639L15.0514 25.201C17.1596 25.3019 19.2432 24.7123 20.9858 23.5215L19.8917 21.9202ZM15.1441 23.2639C13.4575 23.1831 11.8433 22.5543 10.5466 21.4729L9.30446 22.9623C10.9254 24.3141 12.9431 25.1001 15.0514 25.201L15.1441 23.2639ZM10.5466 21.4729C9.24981 20.3915 8.3413 18.9165 7.95894 17.2718L6.06992 17.711C6.54787 19.7668 7.68351 21.6105 9.30446 22.9623L10.5466 21.4729ZM7.95894 17.2718C7.57658 15.6272 7.74126 13.9027 8.42798 12.3601L6.65623 11.5714C5.79783 13.4996 5.59198 15.6552 6.06992 17.711L7.95894 17.2718ZM8.42798 12.3601C9.1147 10.8176 10.286 9.5412 11.764 8.72474L10.8262 7.02714C8.9787 8.04771 7.51463 9.64318 6.65623 11.5714L8.42798 12.3601ZM11.764 8.72474C13.242 7.90829 14.946 7.59636 16.6174 7.8363L16.8929 5.91658C14.8037 5.61666 12.6737 6.00658 10.8262 7.02714L11.764 8.72474ZM16.6174 7.8363C18.2887 8.07623 19.8362 8.85494 21.0248 10.0542L22.4023 8.68896C20.9165 7.18988 18.9822 6.21651 16.8929 5.91658L16.6174 7.8363ZM21.0248 10.0542C22.2134 11.2535 22.9783 12.8078 23.2034 14.4812L25.1255 14.2228C24.8442 12.1309 23.888 10.188 22.4023 8.68896L21.0248 10.0542Z",
    fill: "#0BC196"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.5156,
    y1: 11.6362,
    x2: 15.5156,
    y2: 19.3938,
    stroke: "#0EF1BC",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.6368,
    y1: 15.5149,
    x2: 19.3944,
    y2: 15.5149,
    stroke: "#0EF1BC",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8177 25.5227L23.2622 27.3563C23.7669 27.997 24.7356 28.0042 25.2499 27.371L26.7511 25.5227",
    stroke: "#24D1A8",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.9,
    x1: 0.969697,
    y1: -0.969697,
    x2: 7.75758,
    y2: -0.969697,
    transform: "matrix(0 -1 -1 0 23.3897 25.0503)",
    stroke: "#0EF1BC",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.102d8a88c3c145b9d6246f01b3be02cc.svg";
export { ForwardRef as ReactComponent };